(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dyd-holiday-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const aliases = {'chanukah':'hanukkah','hanuka':'hanukkah','sukkut':'sukkot','succot':'sukkot','ramazan':'ramadan','carnival':'carnaval','sao joao':'festa junina','muslims':'muslim','jews':'jewish','christians':'christian','hindus':'hindu'};
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[-/]/g,' ').replace(/\s+/g,' ').trim();
  const init = root => root.querySelectorAll('[data-holiday-hub]').forEach(hub => {
    const input=hub.querySelector('[data-holiday-search]');
    if(!input || input.dataset.bound) return;
    input.dataset.bound='true';
    const cards=[...hub.querySelectorAll('[data-holiday-card]')];
    const clear=hub.querySelector('[data-holiday-clear]');
    const empty=hub.querySelector('[data-holiday-empty]');
    const filter=()=>{
      let query=normalize(input.value);
      query=aliases[query] || query;
      let visible=0;
      for(const card of cards){const matches=query.split(' ').every(term=>normalize(card.dataset.search).includes(term));card.hidden=!matches;if(matches)visible++;}
      clear.hidden=!input.value;
      empty.hidden=visible>0;
    };
    input.addEventListener('input',filter);
    clear.addEventListener('click',()=>{input.value='';filter();input.focus();});
  });
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target.parentElement || document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dyd-robot-atelier-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dyd-robot-reveal')) {
    customElements.define('dyd-robot-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.controls) return;
        this.controls = new AbortController();
        const options = { signal: this.controls.signal };
        const handle = this.querySelector('.robot-atelier__handle');
        let active = false;
        let position = 50;
        const setPosition = value => {
          position = Math.max(5, Math.min(95, value));
          this.style.setProperty('--robot-position', position + '%');
          handle.setAttribute('aria-valuenow', String(Math.round(position)));
        };
        const move = event => {
          const bounds = this.getBoundingClientRect();
          setPosition((event.clientX - bounds.left) / bounds.width * 100);
        };
        this.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          active = true;
          this.setPointerCapture(event.pointerId);
          move(event);
        }, options);
        this.addEventListener('pointermove', event => { if (active) move(event); }, options);
        this.addEventListener('pointerup', () => { active = false; }, options);
        this.addEventListener('pointercancel', () => { active = false; }, options);
        this.addEventListener('lostpointercapture', () => { active = false; }, options);
        handle.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') setPosition(position - 5);
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') setPosition(position + 5);
          else if (event.key === 'Home') setPosition(5);
          else if (event.key === 'End') setPosition(95);
          else return;
          event.preventDefault();
        }, options);
        setPosition(Number(this.dataset.start) || 50);
      }
      disconnectedCallback() {
        this.controls?.abort();
        this.controls = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
